import React from 'react';
import { SectionLayout } from '../../components/layouts';
import { PostCodeForm } from './components';
import PostCodeResults from './components/PostCodeResults';
import { useReducerAsState } from '../../hooks/useReducerAsState';

interface State {
    isOpenDrawer: boolean;
    postCodeId?: number | null;
}

const PostCodes = () => {
    const [state, setState] = useReducerAsState<State>({
        isOpenDrawer: false,
        postCodeId: null
    });

    const setIsOpenSideDrawer = (value: boolean) => setState({ isOpenDrawer: value });

    const onCloseDrawer = () => setState({ postCodeId: null });

    return (
        <SectionLayout title="Códigos postales">
            <PostCodeResults
                onEditPostCode={(id) => setState({ postCodeId: id })}
                setIsOpenSideDrawer={setIsOpenSideDrawer}
            />
            {state.isOpenDrawer && (
                <PostCodeForm
                    postCodeId={state.postCodeId !== null ? state.postCodeId : undefined}
                    isOpenSideDrawer={state.isOpenDrawer}
                    setIsOpenSideDrawer={setIsOpenSideDrawer}
                    onClose={onCloseDrawer}
                />
            )}
        </SectionLayout>
    );
};

export default PostCodes;
